/**
 *  Pjax処理
 *
 *  data-pjax で指定したSelectorの中身をhrefの中身で置き換える
 **/
$(function() {
  'use strict';

  function applyPjax( event, node ) { 

    var pjax_selector = $(node).data('pjax');
    var pjax_url = $(node).attr('href');

    try { 

      //ローディング表示
      moko.showLoading();

      //スクロール位置を調整
      var scroll_target = $(pjax_selector).offset().top;
      if ( scroll_target < $(window).scrollTop() ) { 
        /*
        $('html, body').animate({
          scrollTop: scroll_target
        }, 1000 );
        */
        $('html,body').scrollTop(scroll_target-100);
        //$(pjax_selector).html('<div></div>');
      }

      //コンテンツ取得して表示
      $.ajax( {
        url : pjax_url,
        type : 'GET',
      })
      .done( function( result ) {
        var content = $(result).find(pjax_selector);
        $(pjax_selector).html(content);
        var replacedRoot = $(pjax_selector).get(0);
        if (replacedRoot && typeof CustomEvent === 'function') {
          document.dispatchEvent(new CustomEvent('customDOMContentLoaded', {
            detail: { root: replacedRoot }
          }));
        }
        window.history.replaceState(null, null, pjax_url);
        moko.hideLoading();
      })
      .fail( function( result ) {
        console.error(result);
        location.href = pjax_url;
      });
    } catch ( ex ) {
      console.error(ex);
      location.href = pjax_url;
    }

    event.preventDefault();
  }


  $(document).on('click','[data-pjax]', function( e ) {  applyPjax( e, this ); } );

});

